import React from "react";
import Typed from "react-typed";

import myImage from "../images/myimage.jpg";

const ProfileQuote = () => {
  return (
    <div id="profile">
      <div className="container profile-container">
        <div className="flex facts">
          <h2>Some Facts About Me</h2>
        </div>
        <div className="row h-auto  profile">
          <div className="profile-image col-md-5">
            <img src={myImage} alt="profile" id="profile-image" />
          </div>
          <div className="col-md-7 white-board">
            <h2>
              <Typed
                strings={[
                  "With over 4+ years of experience in software Engineering domain across different technologies and frameworks, I create impact in the world by building softwares such as Android apps, iPhone apps, modern websites which have amazing features and much more. I have worked with different companies in my professional carrier as a Software Development Engineer.",
                ]}
                typeSpeed={60}
                style={{ color: "#BEBEBE" }}
              />
            </h2>
          </div>
        </div>
        <div className="profile-talk">
          <p>
            Keeping professional life aside, I love to play table tennis,
            cricket and enjoy by listening to my favourite music and spend time
            with myself.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileQuote;
